import { render } from "./footer.vue?vue&type=template&id=4ade7aa0"
const script = {}

import exportComponent from "/home/innovation/Documents/project/for small pos/niyera/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__